import {Component, Inject, LOCALE_ID} from '@angular/core';
import {NgIf} from "@angular/common";
import {NowruzArboricultureComponent} from "../nowruz-arboriculture/nowruz-arboriculture.component";
import {NowruzKheshtComponent} from "../nowruz-khesht/nowruz-khesht.component";
import {NowruzSoorComponent} from "../nowruz-soor/nowruz-soor.component";
import {NowruzSweetsComponent} from "../nowruz-sweets/nowruz-sweets.component";
import {Router} from "@angular/router";
import {GlobalService} from "../../../services/global.service";
import {ConfigService} from "../../../services/config.service";

@Component({
  selector: 'app-nowruz-main-page',
  standalone: true,
    imports: [
        NgIf,
        NowruzArboricultureComponent,
        NowruzKheshtComponent,
        NowruzSoorComponent,
        NowruzSweetsComponent
    ],
  templateUrl: './nowruz-main-page.component.html',
  styleUrl: './nowruz-main-page.component.css'
})
export class NowruzMainPageComponent {

    constructor(public route: Router,
                @Inject(LOCALE_ID) public locale: string,
                public global: GlobalService,
                public conf: ConfigService) {

    }

}
